export default __webpack_public_path__ + "static/SPRITZARBEITEN-c14e2371bee9ea3f46ba7af6558d8d91.jpg";